export const SITE_NAME = "Aksara Systems";
export const SITE_URL = "https://aksarasystems.com";

// Public sovereign explorer where live anchorings (block + tx references)
// are verifiable. Surfaced on the Home landing (intro + footer).
export const EXPLORER_URL = "https://aksarasystems.io";

// Explorer base URLs moved to the per-demo chain registry in
// `src/config/chains.ts` (`explorerBaseUrlForDemo`).

/**
 * Set to true to enable /:lang/* routing (e.g. /en/, /fr/).
 * Set to false for a single-language app — standard routing is used instead.
 */
export const I18N_ROUTING = true;

// Demo API mode (`simulated` vs `live`) is owned by
// `stores/DemoApiModeStore.ts`. The store reads `VITE_DEMO_API_MODE` as
// an initial default but persists user toggles in `localStorage`.
